export default [
    {
        comment: '',
        error_id: 'SKW-00',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: '',
        error_id: 'T-SKW-01',
        data: [
            {cross_section: '4420', degree: 60, skew: 30},
            {cross_section: '5505', degree: 60, skew: 30},
        ]
    },
    {
        comment: '',
        error_id: 'T-SKW-02',
        data: [
            {cross_section: '4420', degree: 60, skew: 30, defined_skew: 50},
            {cross_section: '5505', degree: 60, skew: 30, defined_skew: 50},
        ]
    },
    {
        comment: '',
        error_id: 'SKW-03',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'SKW-04',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    },
    {
        comment: '',
        error_id: 'SKW-05',
        data: [
            {cross_section: '4420'},
            {cross_section: '5505'},
        ]
    }
]